import {useMutation, useQuery} from '@tanstack/react-query'
import {api} from '@/lib/api'
import type {components} from '@/lib/api-schema'
import type {PasoBitacora} from '@/lib/bitacora-sesion'
import {uploadToStorage} from '@/hooks/sgsst/evidencias/use-evidence'

export type FeedbackReporteWrite = components['schemas']['FeedbackReporteWrite']
export type ArchivoRegistro = components['schemas']['ArchivoRegistroWrite']
export type FeedbackReporte = components['schemas']['FeedbackReporteRead']
/** La captura de pantalla: los bytes para subir y la `data:` URL de la miniatura. */
export type Captura = {blob: Blob; url: string}
type ResumenRead = components['schemas']['FeedbackResumenRead']
type UploadTarget = components['schemas']['FeedbackUploadTargetRead']

/** POST porque la bitácora viaja en el cuerpo, pero se lee como consulta: sin reintentos y
 * congelada por diálogo (la clave lleva el largo y el último instante). */
export function useResumenDeSesion(businessId: string, bitacora: PasoBitacora[], enabled: boolean) {
  const ultimo = bitacora[bitacora.length - 1]
  return useQuery({
    queryKey: ['feedback-resumen', businessId, bitacora.length, ultimo?.t ?? 0],
    queryFn: async () => (await api.post<ResumenRead>(`/businesses/${businessId}/feedback/resumen`, {bitacora})).data,
    enabled: enabled && bitacora.length > 0,
    staleTime: Infinity,
    retry: false,
  })
}

export async function subirArchivoDeFeedback(
  businessId: string,
  file: File,
  tipo: ArchivoRegistro['tipo']
): Promise<ArchivoRegistro> {
  const target = (
    await api.post<UploadTarget>(`/businesses/${businessId}/feedback/archivos-uploads`, {
      filename: file.name,
      content_type: file.type,
      size_bytes: file.size,
    })
  ).data
  await uploadToStorage(target, file, () => {})
  return {object_key: target.object_key, filename: file.name, content_type: file.type, size_bytes: file.size, tipo}
}

export function useEnviarFeedback(businessId: string) {
  return useMutation({
    mutationFn: async (input: FeedbackReporteWrite) =>
      (await api.post<FeedbackReporte>(`/businesses/${businessId}/feedback`, input)).data,
    // El diálogo pinta su propio fallo y conserva lo escrito: la red de mutaciones no
    // tiene que avisar por segunda vez.
    meta: {manejaError: true},
  })
}
